module.exports = __webpack_public_path__ + "static/media/engine_temperature.b14ce324.svg";